import {
  CSN_AD_CLICK_FACT_TYPE,
  SEARCH_RESULTS_PAGE,
  PRODUCT,
  getPageUrl,
  AD_CLICK_TARGET_VENUE_PROFILE,
  THREE_DIAMOND_LIST_AD_TYPE,
  DIAMOND_PLUS_AD_TYPE,
  FOUR_DIAMOND_AD_TYPE,
  COMPETITIVE_MARKET_AD_TYPE,
  VIDEO_AD_TYPE
} from '@/utils/analyticsClientHelper';
import type { AdClickFact } from '@/analytics/models/cventAnalytics/AdClickFact';
import type { CsnSearchVenue } from '@/models/CsnSearchVenue';

const INDEX_OFFSET = 1;

// featured level -> ad type to use in fact
const featuredLevelToAdType = new Map([
  ['THREE_DIAMOND', THREE_DIAMOND_LIST_AD_TYPE],
  ['DIAMOND_PLUS', DIAMOND_PLUS_AD_TYPE],
  ['FOUR_DIAMOND', FOUR_DIAMOND_AD_TYPE],
  ['COMPETITIVE_MARKET_AD', COMPETITIVE_MARKET_AD_TYPE],
  ['VIDEO_AD', VIDEO_AD_TYPE]
]);

export function getAdClickFact(
  venue: CsnSearchVenue,
  venueIndex: number,
  isMapExpanded: boolean | null,
  searchTerm: string,
  rfpId: string | null,
  source: string
): AdClickFact {
  const type = featuredLevelToAdType.get(venue.featuredLevel as string) as string;

  return {
    type: CSN_AD_CLICK_FACT_TYPE,
    ad_type: type,
    ads: JSON.stringify({ venueId: venue.id, ad_id: venue.listingCode, position: venueIndex + INDEX_OFFSET }),
    click_target: AD_CLICK_TARGET_VENUE_PROFILE,
    product: PRODUCT,
    page: SEARCH_RESULTS_PAGE,
    page_url: getPageUrl(),
    map_view: isMapExpanded ? 'EXPANDED' : 'COLLAPSED',
    search_term: searchTerm,
    rfp_id: rfpId ?? 'null',
    source
  };
}
